import { fetch } from '../../services/api';
import QueryBuilder from '../../components/WHTable/queryBuilder';

const endPoints = '/api/pages';

export const search = (data) => {

    let query = QueryBuilder(data);

    return fetch(endPoints, query, 'get')

};


export const nav = (data) => {

  let query = QueryBuilder(data);

  query["menu"] =1;

  return fetch(endPoints, query, 'get');
};

export const view = (id) => fetch(`${endPoints}/${id}`, 'get');

export const create = (data) => fetch(`${endPoints}`, data, 'post');

export const update = (data) => fetch(`${endPoints}/${data.id}`, data, 'put');

export const remove = (id) => fetch(`${endPoints}/${id}`, {}, 'delete');


// WEBPACK FOOTER //
// ./src/services/page/index.js